import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import Theme from "@/libs/Theme";
import TagManager from "react-gtm-module";
import { GlobalStyle } from "./styles";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const tagManagerArgs = {
  gtmId: "GTM-N7SV2PH",
};

TagManager?.initialize?.(tagManagerArgs);

root.render(
  <React.StrictMode>
    <Theme>
      <GlobalStyle />
      <App />
    </Theme>
  </React.StrictMode>
);
